import landing from "./views/landing";

export default [
  {
    path: "/",
    component: landing,
    name: "Landing",
  },
];
